import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {ThemeContext} from '../';

const Panel = (props) => {
  const {
    title,
    subtitle,
    renderActions,
    headerSize,
    children,
    theme,
    size,
    cls,
  } = props;
  const panelClasses = classNames(
    `panel ${cls}`,
    {
      [`panel_size_${size}`]: Boolean(size),
    }
  );
  const panelHeaderClasses = classNames(
    'panel__header',
    {
      [`panel__header_${headerSize}`]: Boolean(headerSize),
    }
  );
  const panelContentClasses = classNames(
    'panel__content',
    {
      [`panel__content_${size}`]: Boolean(size),
    }
  );

  return (
    <ThemeContext.Consumer>
      {(template) => {
        const styles = {
          backgroundColor: template[`${theme}Color`],
        };

        return (
          <div className={panelClasses}>
            <div className={panelHeaderClasses} style={styles}>
              <div className="cell">
                <h3 className="panel__title">{title}</h3>
                {subtitle && <div className="panel__text">{subtitle}</div>}
              </div>
              <div className="cell cell_auto">
                {renderActions}
              </div>
            </div>
            <div className={panelContentClasses}>
              {children}
            </div>
          </div>
        );
      }}
    </ThemeContext.Consumer>
  );
};

Panel.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  renderActions: PropTypes.node,
  children: PropTypes.node.isRequired,
  theme: PropTypes.string,
  size: PropTypes.string,
  headerSize: PropTypes.string,
  cls: PropTypes.string,
};

Panel.defaultProps = {
  subtitle: '',
  renderActions: null,
  theme: 'primary',
  size: '',
  headerSize: 'm',
  cls: '',
};

export default Panel;
